import { render, staticRenderFns } from "./modal-editar-chamado-agrupamento.vue?vue&type=template&id=195d1214&scoped=true"
import script from "./modal-editar-chamado-agrupamento.vue?vue&type=script&lang=ts"
export * from "./modal-editar-chamado-agrupamento.vue?vue&type=script&lang=ts"
import style0 from "./modal-editar-chamado-agrupamento.vue?vue&type=style&index=0&id=195d1214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195d1214",
  null
  
)

export default component.exports